import { BaseReactComponent } from "@/Common/Components/BaseReactComponent";

import img_icon_rxvigilancelogo from "@/Globals/_images/icons/vigilance/RXVigilanceLogo.png";

interface VigilanceIconProps {
    id: string;
    onClick: () => void;
    styles?: React.CSSProperties;
    height: string;
}

class VigilanceIcon extends BaseReactComponent<VigilanceIconProps, null> {
    public render(): JSX.Element {
        return (
            <div
                className="pointer"
                onClick={e => {
                    e.stopPropagation();
                    this.props.onClick();
                }}
                style={this.props.styles ?? {}}
            >
                <img
                    style={{ height: this.props.height }}
                    id={this.props.id}
                    src={img_icon_rxvigilancelogo}
                />
            </div>
        );
    }
}

export { VigilanceIcon };
